/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Layout,
  Table,
  Input,
  Badge,
  Avatar,
} from "antd";
import { DELETE_USER, IMAGE_BASE_URL, STAFF } from "../../constants/api";
import { getUserTypeLabel } from "../../constants/constent";

function UserTable() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const formattedData = data["data"]
          .filter((row) => row.user_type !== "superadmin")
          .map((row, index) => ({
            key: index,
            ID: index + 1,
            Type: getUserTypeLabel(row.user_type),
            Name: row.name,
            Email: row.email,
            Phone: row.mobile,
            Image: (
              <Badge>
                <Avatar
                  src={row.image ? IMAGE_BASE_URL + row.image.filePath : ""}
                  shape="circle"
                  size="large"
                />
              </Badge>
            ),
            Action: (
              <Space>
                <Button
                  onClick={() => {
                    navigate("/user/edit/" + row.id);
                  }}
                  block
                >
                  Edit
                </Button>
                <Popconfirm
                  title="Delete the data"
                  description="Are you sure to delete this data?"
                  onConfirm={() => deleteData(row.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button danger>Delete</Button>
                </Popconfirm>
              </Space>
            ),
          }));
        setState(formattedData);
        setFilteredState(formattedData);
      } else {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };
    getAPI(STAFF, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = { id: values };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_USER, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter((user) => {
      const searchTerm = value.toLowerCase();
      return (
        (user.Type && user.Type.toLowerCase().includes(searchTerm)) ||
        (user.Name && user.Name.toLowerCase().includes(searchTerm)) ||
        (user.Email && user.Email.toLowerCase().includes(searchTerm)) ||
        (user.Phone && user.Phone.includes(searchTerm))
      );
    });

    setFilteredState(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Profile",
      dataIndex: "Image",
      width: 50,
    },
    {
      title: "Role",
      dataIndex: "Type",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "Name",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "Email",
      width: 50,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      width: 50,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Staff"
            extra={
              <Space>
                <Input
                  placeholder="Search by Role, Name or Email"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={() => navigate("/user/add")}>
                  Add <PlusOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredState}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default UserTable;
